import { c as _c } from "react/compiler-runtime";
import { Button, Status } from '@systemeio/components';
import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon } from '@systemeio/icons';
interface FunnelStepsCompactNavigationProps {
  currentStep: number;
  nextLabel: string;
  onNext: () => void;
  onOpen: () => void;
  onPrevious: () => void;
  previousLabel: string;
  splitTestStatus?: {
    color: Status.CircleColor;
    label: string;
  };
  stepsLabel: string;
  totalSteps: number;
  title: string;
}
function getAdjacentFunnelStep<T>(funnelSteps: T[] | undefined, selectedStepIndex: number, offset: -1 | 1) {
  return funnelSteps?.[selectedStepIndex + offset];
}
function FunnelStepsCompactNavigation(t0) {
  const $ = _c(36);
  const {
    currentStep,
    nextLabel,
    onNext,
    onOpen,
    onPrevious,
    previousLabel,
    splitTestStatus,
    stepsLabel,
    totalSteps,
    title
  } = t0;
  let t1;
  if ($[0] !== stepsLabel) {
    t1 = <span className="capitalize">{stepsLabel}</span>;
    $[0] = stepsLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currentStep || $[3] !== totalSteps) {
    t2 = <span>{currentStep} / {totalSteps}</span>;
    $[2] = currentStep;
    $[3] = totalSteps;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChevronDownIcon />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onOpen || $[7] !== t1 || $[8] !== t2) {
    t4 = <Button onClick={onOpen} size="sm" variant="link">{t1}{t2}{t3}</Button>;
    $[6] = onOpen;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = currentStep <= 1;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronLeftIcon />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onPrevious || $[12] !== previousLabel || $[13] !== t5) {
    t7 = <Button aria-label={previousLabel} disabled={t5} onClick={onPrevious} size="icon-sm" variant="secondary">{t6}</Button>;
    $[11] = onPrevious;
    $[12] = previousLabel;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = currentStep === 0 || currentStep >= totalSteps;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChevronRightIcon />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== nextLabel || $[17] !== onNext || $[18] !== t8) {
    t10 = <Button aria-label={nextLabel} disabled={t8} onClick={onNext} size="icon-sm" variant="secondary">{t9}</Button>;
    $[16] = nextLabel;
    $[17] = onNext;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t7) {
    t11 = <div className="flex gap-2.5">{t7}{t10}</div>;
    $[20] = t10;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t4) {
    t12 = <div className="flex w-full items-center justify-between">{t4}{t11}</div>;
    $[23] = t11;
    $[24] = t4;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== title) {
    t13 = <span className="text-base font-medium">{title}</span>;
    $[26] = title;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== splitTestStatus) {
    t14 = splitTestStatus && <Status color={splitTestStatus.color} size="md">{splitTestStatus.label}</Status>;
    $[28] = splitTestStatus;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t13 || $[31] !== t14) {
    t15 = <div className="flex flex-wrap items-center gap-x-2 gap-y-1">{t13}{t14}</div>;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t12 || $[34] !== t15) {
    t16 = <div className="flex w-full flex-col gap-1">{t12}{t15}</div>;
    $[33] = t12;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}
export { FunnelStepsCompactNavigation, getAdjacentFunnelStep };